import React, { Component } from "react";
import { Statistic, Button, Responsive, Fragment } from "semantic-ui-react";
import { Link } from "react-router-dom";
import "./dashboard.css";

class RoundStatistics extends Component {
  constructor(props) {
    super(props);
    this.state = { statsWidth: "five" };
    this.handleClick = this.handleClick.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    var x = window.matchMedia("(max-width: 820px)");
    this.handleResize(x);
    x.addListener(this.handleResize);
  }

  handleClick() {}

  handleResize(x) {
    console.log(x);
    this.setState({ statsWidth: x.matches ? "four" : "five" });
  }

  render() {
    return (
      <React.Fragment>
        <Responsive as={Statistic} maxWidth={820}>
          <Button
            className="btn-start"
            style={{ margin: "0 15px" }}
            as={Link}
            to="/grader"
            color="green"
            onClick={this.handleClick}
          >
            Start Reading
          </Button>
        </Responsive>
        <Statistic.Group
          widths={this.state.statsWidth}
          size="mini"
          className="stats-banner"
        >
          <Statistic>
            <Statistic.Value>{this.props.data.num_read_today}</Statistic.Value>
            <Statistic.Label>Reads Today</Statistic.Label>
          </Statistic>
          <Statistic>
            <Statistic.Value>
              {parseInt(this.props.data.total_reads_needed) -
                parseInt(this.props.data.num_graded)}
            </Statistic.Value>
            <Statistic.Label>Reads Left in Round</Statistic.Label>
          </Statistic>
          <Responsive as={Statistic} minWidth={821}>
            <Button
              className="btn-start"
              style={{ margin: "0 15px" }}
              as={Link}
              to="/grader"
              color="green"
              onClick={this.handleClick}
            >
              Start Reading
            </Button>
          </Responsive>
          <Statistic>
            <Statistic.Value>{this.props.data.total_apps_read}</Statistic.Value>
            <Statistic.Label>Total Apps Read</Statistic.Label>
          </Statistic>

          <Statistic>
            <Statistic.Value>0 {/*TODO*/}</Statistic.Value>
            <Statistic.Label>Applicants Accepted</Statistic.Label>
          </Statistic>
        </Statistic.Group>
      </React.Fragment>
    );
  }
}

export default RoundStatistics;



// WEBPACK FOOTER //
// ./src/components/dashboard/RoundStatistics.js